import axios from "axios";
import { ENDPOINTS, getBaseURL } from "data/endpoints";
import { getHeaders } from "data/headers";
import { SURVEY_STATUS_ASSIGNED } from "utils/constants";
import { getDeviceTypeQueryParams } from "utils/device";
import { getIpqsToastMessage } from "utils/security-messages";

import { SurveyListRequest, UpdateSurveyRequest } from "./interface";

export const getSurveyListApi = (payload: SurveyListRequest) => {
  let url = `${ENDPOINTS.USER_SURVEY}?status=${payload.status}&page_size=${payload.pageSize}&page=${payload.page}`;
  if (payload.status === SURVEY_STATUS_ASSIGNED) {
    url += `&${getDeviceTypeQueryParams()}`;
  }
  return axios.get(getBaseURL() + url, {
    headers: getHeaders(),
  });
};

//TODO: can be combined with above method. For now, instead of saving to redux directly using the response
export const getSurveyListPaginationApi = async (
  payload: SurveyListRequest,
) => {
  try {
    let url = `${ENDPOINTS.USER_SURVEY}?status=${payload.status}&page_size=${payload.pageSize}&page=${payload.page}`;
    if (payload.status === SURVEY_STATUS_ASSIGNED) {
      url += `&${getDeviceTypeQueryParams()}`;
    }
    const { data } = await axios.get(getBaseURL() + url, {
      headers: getHeaders(),
    });

    return data;
  } catch (e) {
    return {
      message: e.response?.data?.message,
      response: { count: 0, rows: [] },
    }; //manually added error for erro snackbar validation
  }
};

export const surveyIncreaseClicks = async (id: number) => {
  try {
    const url = `${ENDPOINTS.INCREASE_CLICKS}${id}`;
    const { data } = await axios.get(getBaseURL() + url, {
      headers: getHeaders(),
    });

    return data;
  } catch (e) {
    return {
      message:
        getIpqsToastMessage(e.response?.data?.message) ??
        e.response?.data?.message,
    };
  }
};

export const surveyUpdate = async (request: UpdateSurveyRequest) => {
  try {
    const { data } = await axios.post(
      getBaseURL() + ENDPOINTS.UPDATE_SURVEY,
      request,
      {
        headers: getHeaders(),
      },
    );

    return data;
  } catch (e) {
    return {
      message: e.response?.data?.message,
    };
  }
};

export const recordSurveyFailure = async (payload: {
  surveyId?: string;
  userId: string;
  clientStatus?: string;
  marketplaceStatus?: string;
  surveyNumber?: string;
  providerId?: number;
  status?: string;
  tolunaUrl?: string;
  additionalDetails?: null;
}) => {
  try {
    const { data } = await axios.post(
      getBaseURL() + ENDPOINTS.SURVEY_FAILURE,
      payload,
      {
        headers: getHeaders(),
      },
    );

    return data;
  } catch (e) {
    return {
      message: e.response?.data?.message,
    };
  }
};
